import React from 'react';
import {Control, useWatch} from 'react-hook-form';
import {getPasswordStrength} from '../utils/password';
import {PasswordStrength} from './PasswordStrength';

interface PasswordStrengthWatchProps {
  control: Control<{
    currentPassword: string;
    password: string;
    confirmPassword: string;
  }>;
}

export const PasswordStrengthWatch = ({
  control,
}: PasswordStrengthWatchProps) => {
  const password = useWatch({
    control,
    name: 'password',
  });

  const passwordStrength = getPasswordStrength(password);

  return (
    <PasswordStrength
      strength={passwordStrength}
      password={password as string}
    />
  );
};
